import actions from './actions';
import { createReducer } from '../../../../helpers/reducer';

const initState = {
  cards: null,
  bankAccounts: null,
  loading: false,
};

function onLoad(state) {
  return {
    ...state,
    loading: true,
  };
}

function onLoadSuccess(state, { payload }) {
  const { data } = payload;
  const { cards, bank_accounts: bankAccounts } = data;

  return {
    ...state,
    cards,
    bankAccounts,
    loading: false,
  };
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [actions.LOAD]: onLoad,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.CLEAR_STORE]: onClearStore,
});
